import { createHorizontalRule } from './input-rule';
export var insertHorizontalRule = function insertHorizontalRule(editorAnalyticsAPI) {
  return function (inputMethod) {
    return function (state, dispatch) {
      var tr = createHorizontalRule(state, state.selection.from, state.selection.to, inputMethod, editorAnalyticsAPI);
      if (tr) {
        if (dispatch) {
          dispatch(tr);
        }
        return true;
      }
      return false;
    };
  };
};